// Campanha com prazo (snippets/body-campanha.liquid): mostra só entre início e fim
// e atualiza o relógio a cada segundo. Pelo relógio do visitante, porque a página
// pode ter vindo do cache. Elementos novos (cards carregados depois) entram sozinhos.
(() => {
  const dois = (n) => String(n).padStart(2, '0');
  const formatar = (ms) => {
    const s = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    if (d >= 1) return `${d} ${d === 1 ? 'dia' : 'dias'} e ${h}h`;
    return `${dois(h)}h ${dois(m)}min ${dois(s % 60)}s`;
  };
  const passo = () => {
    const agora = Date.now();
    document.querySelectorAll('[data-body-campanha]').forEach((el) => {
      const fim = Date.parse(el.dataset.fim);
      const ativa = agora >= Date.parse(el.dataset.inicio) && agora < fim;
      if (el.hidden === ativa) el.hidden = !ativa;
      if (ativa) el.querySelectorAll('[data-body-relogio]').forEach((r) => { r.textContent = formatar(fim - agora); });
    });
  };
  passo();
  setInterval(passo, 1000);
})();
